var _mask, _path, _g, _path2, _path3, _path4, _path5, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 210,
    viewBox: "0 0 117 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_554_90",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3105 210L58.3105 210L58.3106 108L60.3106 108L60.3105 210Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3105 210L61.3105 206.94L59.3105 206.94L59.3105 210L61.3105 210ZM61.3105 202.86L61.3105 196.74L59.3105 196.74L59.3105 202.86L61.3105 202.86ZM61.3105 192.66L61.3105 186.54L59.3105 186.54L59.3105 192.66L61.3105 192.66ZM61.3105 182.46L61.3105 176.34L59.3105 176.34L59.3105 182.46L61.3105 182.46ZM61.3106 172.26L61.3106 166.14L59.3106 166.14L59.3106 172.26L61.3106 172.26ZM61.3106 162.06L61.3106 155.94L59.3106 155.94L59.3106 162.06L61.3106 162.06ZM61.3106 151.86L61.3106 145.74L59.3106 145.74L59.3106 151.86L61.3106 151.86ZM61.3106 141.66L61.3106 135.54L59.3106 135.54L59.3106 141.66L61.3106 141.66ZM61.3106 131.46L61.3106 125.34L59.3106 125.34L59.3106 131.46L61.3106 131.46ZM61.3106 121.26L61.3106 115.14L59.3106 115.14L59.3106 121.26L61.3106 121.26ZM61.3106 111.06L61.3106 108L59.3106 108L59.3106 111.06L61.3106 111.06ZM62.3105 210L62.3105 206.94L58.3105 206.94L58.3105 210L62.3105 210ZM62.3105 202.86L62.3105 196.74L58.3105 196.74L58.3105 202.86L62.3105 202.86ZM62.3105 192.66L62.3105 186.54L58.3105 186.54L58.3105 192.66L62.3105 192.66ZM62.3105 182.46L62.3105 176.34L58.3105 176.34L58.3105 182.46L62.3105 182.46ZM62.3106 172.26L62.3106 166.14L58.3106 166.14L58.3106 172.26L62.3106 172.26ZM62.3106 162.06L62.3106 155.94L58.3106 155.94L58.3106 162.06L62.3106 162.06ZM62.3106 151.86L62.3106 145.74L58.3106 145.74L58.3106 151.86L62.3106 151.86ZM62.3106 141.66L62.3106 135.54L58.3106 135.54L58.3106 141.66L62.3106 141.66ZM62.3106 131.46L62.3106 125.34L58.3106 125.34L58.3106 131.46L62.3106 131.46ZM62.3106 121.26L62.3106 115.14L58.3106 115.14L58.3106 121.26L62.3106 121.26ZM62.3106 111.06L62.3106 108L58.3106 108L58.3106 111.06L62.3106 111.06Z",
    fill: "#777777",
    mask: "url(#path-1-inside-1_554_90)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_554_90)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 105,
    height: 105,
    rx: 52.5,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2088 63.1453H38.8524C38.0794 63.1091 37.3073 63.2337 36.5849 63.5114C35.8625 63.7891 35.2057 64.2136 34.6559 64.7583C34.1062 65.303 33.6755 65.9559 33.3911 66.6756C33.1068 67.3953 32.9749 68.1663 33.0039 68.9396V74.6046C33.0039 75.8023 33.3603 76.1587 34.6113 76.1587H46.0838V68.8208C46.0441 67.5168 46.4564 66.2392 47.2508 65.2044C48.0452 64.1696 49.1729 63.4413 50.4428 63.1427H39.2088V63.1453Z",
    fill: "url(#paint0_linear_554_90)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9871 56.8224C69.285 56.8266 70.5709 56.575 71.7716 56.0821C72.9722 55.5892 74.0641 54.8647 74.9847 53.9498C75.9053 53.035 76.6367 51.9477 77.1371 50.7502C77.6375 49.5526 77.8971 48.2683 77.9011 46.9704C77.8975 44.3367 76.8533 41.8111 74.9961 39.9437C73.1389 38.0763 70.619 37.0184 67.9853 37.0004C66.6905 36.9881 65.406 37.232 64.2057 37.718C63.0055 38.2041 61.9132 38.9227 60.9918 39.8325C60.0703 40.7423 59.338 41.8254 58.8367 43.0194C58.3355 44.2133 58.0754 45.4947 58.0713 46.7896C58.0729 49.4297 59.1145 51.963 60.9703 53.8408C62.8262 55.7186 65.3471 56.7898 67.9871 56.8224Z",
    fill: "url(#paint1_linear_554_90)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5336 43.5609C43.3332 43.5506 41.2183 44.412 39.6513 45.9568C38.0843 47.5016 37.1927 49.6039 37.1715 51.8043C37.1522 53.4521 37.6222 55.0686 38.5219 56.4493C39.4216 57.83 40.7106 58.9128 42.2259 59.5607C43.7411 60.2086 45.4145 60.3925 47.0343 60.0891C48.6541 59.7857 50.1475 59.0086 51.3256 57.8563C52.5036 56.7039 53.3134 55.228 53.6524 53.6153C53.9914 52.0025 53.8445 50.3255 53.2301 48.7963C52.6158 47.2672 51.5617 45.9546 50.2011 45.0247C48.8406 44.0947 47.2348 43.5893 45.5869 43.5722H45.5328L45.5336 43.5609Z",
    fill: "url(#paint2_linear_554_90)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2774 67.5698C83.2128 63.2108 80.3536 60.2861 76.0478 60.2214H59.8634C55.569 60.2861 52.7002 63.2099 52.6338 67.5052V74.2491C52.6338 75.7341 53.1081 76.1587 54.5434 76.1587H81.2918C82.7769 76.1587 83.2014 75.7376 83.2014 74.2491C83.2774 72.0477 83.2774 69.8358 83.2774 67.5698Z",
    fill: "url(#paint3_linear_554_90)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.3105,
    y: 210,
    width: 22,
    height: 22,
    rx: 11,
    transform: "rotate(-180 70.3105 210)",
    fill: "#00D8A2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_554_90",
    x: 0,
    y: 0,
    width: 117,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_554_90"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_554_90",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_90",
    x1: 41.7214,
    y1: 63.1392,
    x2: 41.7214,
    y2: 76.1587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_554_90",
    x1: 67.9862,
    y1: 37,
    x2: 67.9862,
    y2: 56.8225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_554_90",
    x1: 45.5007,
    y1: 43.5608,
    x2: 45.5007,
    y2: 60.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_554_90",
    x1: 67.9556,
    y1: 60.2214,
    x2: 67.9556,
    y2: 76.1587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/Clients.a92c7e381a2de2e0f209ee4683971824.svg";
export { ForwardRef as ReactComponent };